export interface IAreaHotspot {
  id: string
  nameKey: string
  lat: number
  lng: number
}

export const POPULAR_HOTSPOTS: readonly IAreaHotspot[] = [
  { id: 'shinjuku', nameKey: 'shinjuku', lat: 35.6896, lng: 139.6998 },
  { id: 'shibuya', nameKey: 'shibuya', lat: 35.6580, lng: 139.7016 },
  { id: 'ginza', nameKey: 'ginza', lat: 35.6715, lng: 139.7649 },
  { id: 'ikebukuro', nameKey: 'ikebukuro', lat: 35.7295, lng: 139.7109 },
  { id: 'ueno', nameKey: 'ueno', lat: 35.7118, lng: 139.7773 },
  { id: 'asakusa', nameKey: 'asakusa', lat: 35.7147, lng: 139.7966 },
  { id: 'roppongi', nameKey: 'roppongi', lat: 35.6627, lng: 139.7312 },
  { id: 'akihabara', nameKey: 'akihabara', lat: 35.6983, lng: 139.7731 },
  { id: 'tsukiji', nameKey: 'tsukiji', lat: 35.6655, lng: 139.7707 },
  { id: 'ebisu', nameKey: 'ebisu', lat: 35.6467, lng: 139.7101 },
  { id: 'yokohama', nameKey: 'yokohama', lat: 35.4437, lng: 139.6380 },
  { id: 'nagoya', nameKey: 'nagoya', lat: 35.1814, lng: 136.9064 },
  { id: 'osaka', nameKey: 'osaka', lat: 34.7024, lng: 135.4959 },
  { id: 'kyoto', nameKey: 'kyoto', lat: 35.0116, lng: 135.7681 },
  { id: 'kobe', nameKey: 'kobe', lat: 34.6901, lng: 135.1955 },
  { id: 'hiroshima', nameKey: 'hiroshima', lat: 34.3853, lng: 132.4553 },
  { id: 'fukuoka', nameKey: 'fukuoka', lat: 33.5902, lng: 130.4017 },
  { id: 'sapporo', nameKey: 'sapporo', lat: 43.0618, lng: 141.3545 },
  { id: 'chiyoda', nameKey: 'chiyoda', lat: 35.6940, lng: 139.7538 },
  { id: 'chuo', nameKey: 'chuo', lat: 35.6708, lng: 139.7715 },
  { id: 'minato', nameKey: 'minato', lat: 35.6585, lng: 139.7514 },
  { id: 'taito', nameKey: 'taito', lat: 35.7126, lng: 139.7798 },
  { id: 'toshima', nameKey: 'toshima', lat: 35.7263, lng: 139.7169 },
  { id: 'shinagawa', nameKey: 'shinagawa', lat: 35.6092, lng: 139.7303 },
  { id: 'meguro', nameKey: 'meguro', lat: 35.6415, lng: 139.6982 },
  { id: 'setagaya', nameKey: 'setagaya', lat: 35.6466, lng: 139.6533 },
  { id: 'hakata', nameKey: 'hakata', lat: 33.5932, lng: 130.4206 },
]
